import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { COLOR, FONT_SIZE, FONT_WEIGHT, SPACE } from 'Theme'

const StyledText = styled(Text)`
  text-transform: uppercase;
`

export const DashboardTestimonial = ({
  feedback,
  clientName,
  consultationName,
}) => (
  <Flex px={SPACE.PX_30} py={SPACE.PX_20} flexDirection="column">
    <Flex mb={SPACE.PX_10}>
      <StyledText
        color={COLOR.GRAYSCALE_1}
        fontSize={FONT_SIZE.PX_12}
        fontWeight={FONT_WEIGHT.MEDIUM}
      >
        {`${clientName} · ${consultationName}`}
      </StyledText>
    </Flex>
    <Text fontSize={FONT_SIZE.PX_14} color={COLOR.GRAYSCALE_1}>
      {feedback}
    </Text>
  </Flex>
)

DashboardTestimonial.propTypes = {
  feedback: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  consultationName: PropTypes.string.isRequired,
}
